import { get, post } from '@/api/index'
import { ref } from 'vue';

const isTest = ref<boolean>(process.env.NODE_ENV === "production");
const devUrl = ref<string>('https://scraping-apidev.tobecon.io');
const prdUrl = ref<string>('https://scraping-api.tobecon.io');

export default {
    IsValidReceiptId(serviceName: string, receiptId: string): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/valid-receiptId?receiptId=${ encodeURIComponent(receiptId) }`
        })
    },

    isExpireReceiptId(serviceName: string, receiptId: string): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/expire-receiptId?receiptId=${ encodeURIComponent(receiptId) }`
        })
    },

    GetStatus(serviceName: string, receiptId: string): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/status?receiptId=${ encodeURIComponent(receiptId) }`
        })
    },

    RequestScraping(serviceName: string, scrapingReq: ScrapingReq): Promise<CommonResponse<boolean>> {
        return post<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/scraping-request`,
            data: scrapingReq
        })
    },

    ConfirmScraping_obesity(serviceName: string, receiptId: string): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/scraping-confirm?receiptId=${ encodeURIComponent(receiptId) }`
        })
    },

    ConfirmScraping(serviceName: string, confirmReq: SCrapingConfirmReq): Promise<CommonResponse<boolean>> {
        return post<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/scraping-confirm`,
            data: confirmReq
        })
    },

    UpdateAgree(serviceName: string, agreeReq:AgreeReq): Promise<CommonResponse<boolean>> {
        return post<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/agree`,
            data: agreeReq
        })
    },

    CheckAgree(serviceName: string, receiptId: string): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/${ serviceName }/check-agree?receiptId=${ encodeURIComponent(receiptId) }`,
        })
    },

    GetUserInfo_AdmCritical(receiptId: string): Promise<CommonResponse<UserInfo_AdmCritical>> {
        return get<CommonResponse<UserInfo_AdmCritical>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/admcritical/user?receiptId=${ encodeURIComponent(receiptId) }`,
        })
    },

    GetUserInfo_Obesity(receiptId: string): Promise<CommonResponse<UserInfo_Obesity>> {
        return get<CommonResponse<UserInfo_Obesity>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/obesity/user?receiptId=${ encodeURIComponent(receiptId) }`,
        })
    },

    GetResultList(serviceName: string, receiptId: string): Promise<CommonResponse<any[]>> {
        return get<CommonResponse<any[]>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: `/samsungfire/api/admcritical/result-list?receiptId=${ encodeURIComponent(receiptId) }`,
        })
    },
}